import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Snackbar, Alert } from '@mui/material';
import { Wifi as WifiIcon, WifiOff as WifiOffIcon } from '@mui/icons-material';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationSeverity, setNotificationSeverity] = useState('info');

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setNotificationMessage('Back online!');
      setNotificationSeverity('success');
      setShowNotification(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setNotificationMessage('You are currently offline. Some features may not work.');
      setNotificationSeverity('warning');
      setShowNotification(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowNotification(false);
  };

  // Don't render anything if online (minimal UI)
  if (isOnline) {
    return null;
  }

  return (
    <>
      {/* Offline indicator in corner */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: 9999,
          bgcolor: 'warning.main',
          color: 'warning.contrastText',
          borderRadius: 2,
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          boxShadow: 3,
        }}
      >
        <WifiOffIcon fontSize="small" />
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Offline
        </Typography>
      </Box>

      {/* Notification Snackbar */}
      <Snackbar
        open={showNotification}
        autoHideDuration={isOnline ? 3000 : 6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notificationSeverity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {notificationMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default NetworkStatus;
